<template>
	<div class="sidebar">
		<div class="sidebar__brand">
			<img src="@/assets/logo-white.svg" alt="recycle race" />
		</div>
		<nav class="sidebar__nav">
			<SidebarItem
				class="sidebar__nav__item"
				v-for="link in links"
				:key="link.name"
				v-bind="link"
				@click.native="$emit('navigate')"
			/>
		</nav>
		<User invert />
	</div>
</template>

<script>
import IconDashboard from 'mdi-vue/ViewDashboard'
import IconCompetitions from 'mdi-vue/Flag'
import IconAdd from 'mdi-vue/FlagPlus'
import IconSettings from 'mdi-vue/Cog'
import IconModeration from 'mdi-vue/AccountOff'
import IconReporting from 'mdi-vue/ChartBar'
import IconLogout from 'mdi-vue/Logout'

import SidebarItem from '@/components/SidebarItem'
import User from '@/components/User'

export default {
	name: 'Sidebar',
	data() {
		return {
			links: [
				{ name: 'Dashboard', icon: IconDashboard },
				{ name: 'Manage Competitions', icon: IconCompetitions },
				{ name: 'Create Competition', icon: IconAdd },
				{ name: 'Global Settings', icon: IconSettings },
				{ name: 'Moderation', icon: IconModeration },
				{ name: 'Reporting', icon: IconReporting },
				{ name: 'Log Out', icon: IconLogout },
			],
		}
	},
	components: {
		SidebarItem,
		User,
	},
}
</script>

<style lang="scss" scoped>
@import '~scss/vars';
@import '~scss/mq';

.sidebar {
	$pad: 1.5rem;

	display: flex;
	flex-direction: column;
	width: 18rem;
	height: 100%;
	background-color: $col-primary;
	padding: 0 $pad;
	z-index: 1000;

	&__brand {
		padding: $pad 0;
		border-bottom: 1px solid $white;

		img {
			width: 100%;
			display: block;
		}
	}

	&__nav {
		flex-grow: 1;
		margin-top: $pad;
	}

	.user {
		margin: $pad 0;
	}

	@include mq(md) {
		.user {
			display: none;
		}
	}

	@include mq(lg) {
		&__nav__item {
			margin-right: -$pad;
		}
	}
}
</style>
